<template>
    <el-row>
        <el-col>
            <el-button v-for="item in list" :key="item.code" @click="goToPage(item)">{{item.name}}</el-button>
        </el-col>
    </el-row>
</template>
<script>

export default {
    name:"rk_cd",
    props: {
        current: {
            type:String
        },
        list:{
            type:Array
        }
    },
    data(){
        return{
            // list: [],
            // outMenuEnum
        }
    },
    mounted() {
        // let that = this;
        // this.list = outMenuEnum.outMenuEnum.filter(item => {
        //     let permissionInfo = store.getters.permissionInfo;
        //     return item.text!=that.current&&permissionInfo.indexOf(item.text) >=0
        //     });
        // if(this.list.length==1){
        //     this.$emit("goTo",this.list[0].url);//直接跳转到对应页面
        // }else{
        //     let houTai = outMenuEnum.getInfo(outMenuEnum.HT);
        //     if(this.list.length==0){
        //         this.$emit("goTo",houTai.url);//直接跳转到对应页面
        //     }
        //     this.list.push(houTai);//其他情况添加后台管理菜单
        // }
    },
    methods: {
        goToPage(item){
            this.$emit("goTo",item.url);
        }
    }
}
</script>
<style scoped>
.el-button {
    font-size: 20px;
    font-weight: 300;
    color: #fff;
    cursor: pointer;
    outline: none;
    padding: 17px 15px;
    width: 100%;
    border: 3px solid #0791fa;
    background: #0791fa;
    border-radius: 0.3em;
    -o-border-radius: 0.3em;
    -webkit-border-radius: 0.3em;
    -moz-border-radius: 0.3em;
    margin: 5px;
}

button:hover {
    background: none;
    border: 3px solid #0791fa;
    color: #0791fa;

}
</style>



// WEBPACK FOOTER //
// src/components/ruKou_caiDan.vue